import raw from './reply-emoji-categories.json'

export type ReplyEmojiCategory = {
  name: string
  icon: string
  emojis: string[]
}

export const REPLY_EMOJI_CATEGORY_ORDER = [
  'faces',
  'hands',
  'gestures',
  'animals',
  'food',
  'travel',
  'flags',
  'symbols',
  'objects',
] as const

export type ReplyEmojiCategoryKey = (typeof REPLY_EMOJI_CATEGORY_ORDER)[number]

export const REPLY_EMOJI_CATEGORIES = raw as Record<ReplyEmojiCategoryKey, ReplyEmojiCategory>
